import { useState, useEffect } from 'react';
import { getServerConfig } from '../config/apiConfig';

export const useServerConfig = () => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        setLoading(true);
        const serverConfig = await getServerConfig();
        setConfig(serverConfig);
        setError(null);
      } catch (err) {
        setError(err.message);
        console.error('Failed to fetch server configuration:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchConfig();
  }, []);

  return { config, loading, error };
};
